import { Chip, Stack, TextField } from "@mui/material";
import React, { useMemo } from "react";
import { InputControl, ServerPaginatedtable } from "../../../shared";
import { createColumnHelper } from "@tanstack/react-table";
import { useReferences } from "../../References/hooks/useReferences";

export const RecipeReferences = (props) => {
  const { id } = props;
  const {
    references,
    referencesListQuery,
    sorting,
    pagination,
    search,
    onSearchChange,
    setPagination,
    moduleName,
    setSorting,
    handleFilterChange,
    statusList,
  } = useReferences({ isReferencesList: true, id, type: "recipe" });

  const columnHelper = createColumnHelper();
  const columns = useMemo(
    () => [
      columnHelper.accessor("name", {
        header: () => "Recipe Name",
      }),

      columnHelper.accessor("status", {
        header: "Status",
        cell: ({ row }) => {
          return row?.original.status ? (
            <Chip
              size="small"
              color="primary"
              variant="filled"
              label="ACTIVE"
            />
          ) : (
            <Chip size="small" color="gray" label="INACTIVE" />
          );
        },
      }),

      columnHelper.display({
        id: "actions",
        cell: (props) => {
          return <img alt="details" src="/icons/arrow_forward.png" />;
        },
      }),
    ],
    [referencesListQuery?.data?.recipe]
  );

  return (
    <>
      <ServerPaginatedtable
        defaultData={referencesListQuery?.data?.recipe ?? []}
        columns={columns}
        search={search}
        onSearchChange={onSearchChange}
        sorting={sorting}
        setSorting={(callback) =>
          setSorting({ tableName: moduleName, callback })
        }
        pagination={pagination}
        paginationProps={
          referencesListQuery.data?.pagination || { total: 0, lastPage: 1 }
        }
        setPagination={(callback) =>
          setPagination({ tableName: moduleName, callback })
        }
        headerText="Recipes"
        isLoading={referencesListQuery?.isLoading}
        onRowLink={(e) => {
          return `/recipe/details/${e.id}/?basic-details`;
        }}
        tableHeaderContent={
          <Stack
            sx={{
              flexDirection: "row",
              gap: "8px",
            }}
          >
            <InputControl
              type="dropdown"
              variant="filter"
              size="small"
              options={statusList}
              getOptionLabel={(option) => option?.label || ""}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              sx={{
                width: "180px",
                height: "36px",
                mr: "18px",
              }}
              value={
                statusList?.find((option) => option.id === references.status) ||
                null
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Status" />
              )}
              onChange={(event, option) => handleFilterChange(option)}
            />
          </Stack>
        }
        headerStyle={{
          px: 0,
          fontSize: "18px",
          fontWeight: 500,
          height: "56px",
          py: "12px",
          borderBottom: "1px solid #E0E0E0",
        }}
        headerContentStyle={{ px: 0 }}
        enableTableContainerPaddingBottom
      />
    </>
  );
};
